<template>
  <div class="appService">
     <iframe class="innerHtml" frameborder="0" scrolling="auto" :src="url"></iframe>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: 'http://cdn.zxzx119.com/zz_service.html'
    }
  }
}
</script>

<style lang="scss" scoped>
.appService{
  display: inline-block;
  width: 100%;
  height: 100vh;
.innerHtml{
  display: inline-block;
  height: 100%;
  width: 100%;
}
}

</style>



// WEBPACK FOOTER //
// src/view/app/appservive.vue